'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _themeSections = require('@shopify/theme-sections');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _variants = require('../modules/variants');

var _variants2 = _interopRequireDefault(_variants);

var _themeCurrency = require('@shopify/theme-currency');

var _slickCarousel = require('slick-carousel');

var _slickCarousel2 = _interopRequireDefault(_slickCarousel);

var _slick = require('../modules/slick');

var _slick2 = _interopRequireDefault(_slick);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var selectors = {
  addToCart: '[data-add-to-cart]',
  addToCartText: '[data-add-to-cart-text]',
  addToCartInput: '[data-add-button-input]',
  comparePrice: '[data-compare-price]',
  comparePriceText: '[data-compare-text]',
  originalSelectorId: '[data-product-select]',
  priceWrapper: '[data-price-wrapper]',
  productImageWrapper: '[data-product-image-wrapper]',
  productFeaturedImage: '[data-product-featured-image]',
  productJson: '[data-product-json]',
  productPrice: '[data-product-price]',
  productThumbs: '[data-product-single-thumbnail]',
  singleOptionSelector: '[data-single-option-selector]'
};

exports.default = (0, _themeSections.register)('template-product', {
  onLoad: function onLoad() {
    this.$container = (0, _jquery2.default)(this.container);
    this.namespace = '.' + this.id;

    // Product images
    var slideshows = this.$container.find('[data-product-images]');
    _jquery2.default.each(slideshows, function (index, value) {
      var slideshow = (0, _jquery2.default)(slideshows[index]);

      var settings = (0, _slick2.default)({
        adaptiveHeight: true,
        appendArrows: slideshow.closest('.slick-slider-wrapper').find('.slick-arrows'),
        appendDots: slideshow.closest('.slick-slider-wrapper').find('.slick-dots-wrapper'),
        prevArrow: slideshow.closest('.slick-slider-wrapper').find('[data-slick-prev]'),
        nextArrow: slideshow.closest('.slick-slider-wrapper').find('[data-slick-next]'),
        dots: true,
        slidesToShow: 2,
        slidesToScroll: 2,
        responsive: [{
          breakpoint: Breakpoints['large'],
          settings: {
            arrows: true,
            dots: false,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }]
      });

      slideshow.slick(settings);
    });

    // Product image lightbox
    var PopupProductImages = new Limelight('#PopupProductImages', {
      bodyClass: 'active-popup',
      hideCallback: function hideCallback(element, elements) {
        var slideshow = (0, _jquery2.default)(element.target).find('[data-product-images-popup]');
        slideshow.slick('unslick');
      }
    });

    var lightboxTriggers = this.$container.find('[data-lightbox]');
    (0, _jquery2.default)(lightboxTriggers).on('click', function (event) {
      var slideIndex = (0, _jquery2.default)(this).data('lightbox');
      var slideshow = (0, _jquery2.default)(PopupProductImages.target).find('[data-product-images-popup]');

      var settings = (0, _slick2.default)({
        adaptiveHeight: true,
        appendArrows: slideshow.closest('.slick-slider-wrapper').find('.slick-arrows'),
        appendDots: slideshow.closest('.slick-slider-wrapper').find('.slick-dots-wrapper'),
        prevArrow: slideshow.closest('.slick-slider-wrapper').find('[data-slick-prev]'),
        nextArrow: slideshow.closest('.slick-slider-wrapper').find('[data-slick-next]'),
        dots: true,
        arrows: true,
        initialSlide: slideIndex
      });

      PopupProductImages.show();
      slideshow.slick(settings);
    });

    // Update any lazy images
    var trigger = new Event('lazy:reload');
    document.dispatchEvent(trigger);

    // Variant functions
    if (!(0, _jquery2.default)(selectors.productJson, this.$container).html()) {
      return;
    }

    this.productSingleObject = JSON.parse((0, _jquery2.default)(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.variants = new _variants2.default(options);
    this.$featuredImage = (0, _jquery2.default)(selectors.productFeaturedImage, this.$container);

    // Quantity select changes
    var quantitySelects = this.$container.find('[data-quantity]');
    (0, _jquery2.default)(quantitySelects).on('change', function (event) {
      if ((0, _jquery2.default)(this).is(':checked')) {
        (0, _jquery2.default)('[name="quantity"]').val((0, _jquery2.default)(this).val());
      }
    });

    // Variant callbacks
    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));
  },


  /**
   * Updates the DOM state of the add to cart button
   *
   * @param {boolean} enabled - Decides whether cart is enabled or disabled
   * @param {string} text - Updates the text notification content of the cart
   */
  updateAddToCartState: function updateAddToCartState(evt) {
    var variant = evt.variant;

    if (variant) {
      (0, _jquery2.default)(selectors.priceWrapper, this.$container).removeClass('hide');
    } else {
      (0, _jquery2.default)(selectors.addToCart, this.$container).prop('disabled', true);
      (0, _jquery2.default)(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
      (0, _jquery2.default)(selectors.priceWrapper, this.$container).addClass('hide');
      return;
    }

    if (variant.available) {
      (0, _jquery2.default)(selectors.addToCart, this.$container).prop('disabled', false);
      (0, _jquery2.default)(selectors.addToCartText, this.$container).html(theme.strings.addToCart);

      setTimeout(function () {
        (0, _jquery2.default)(selectors.addToCartInput, this.$container).removeClass('hide');
      }, 500);
    } else {
      (0, _jquery2.default)(selectors.addToCart, this.$container).prop('disabled', true);
      (0, _jquery2.default)(selectors.addToCartText, this.$container).html(theme.strings.soldOut);

      setTimeout(function () {
        (0, _jquery2.default)(selectors.addToCartInput, this.$container).addClass('hide');
      }, 500);
    }
  },


  /**
   * Updates the DOM with specified prices
   *
   * @param {string} productPrice - The current price of the product
   * @param {string} comparePrice - The original price of the product
   */
  updateProductPrices: function updateProductPrices(evt) {
    var variant = evt.variant;
    var $comparePrice = (0, _jquery2.default)(selectors.comparePrice, this.$container);
    var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

    (0, _jquery2.default)(selectors.productPrice, this.$container).html((0, _themeCurrency.formatMoney)(variant.price, theme.moneyFormat));

    if (variant.compare_at_price > variant.price) {
      $comparePrice.html((0, _themeCurrency.formatMoney)(variant.compare_at_price, theme.moneyFormat));
      $compareEls.removeClass('hide');
    } else {
      $comparePrice.html('');
      $compareEls.addClass('hide');
    }
  },
  onUnload: function onUnload() {}
});